import React, { forwardRef } from 'react';
import { Checkbox as HeadlessCheckbox } from '@headlessui/react';

interface CheckboxProps {
  label: string | React.JSX.Element;
  error?: string;
  disabled?: boolean;
  className?: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  name?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ 
    label, 
    error, 
    disabled = false, 
    className = '', 
    checked,
    onChange,
    name,
    ...props 
  }, ref) => {
    return (
      <div>
        <div className='flex flex-row justify-end items-center'>
          <div
            className={`text-sm font-medium text-right mr-3 ${
              disabled ? 'text-gray-400 cursor-not-allowed' : 'text-gray-700'
            }`}
          >
            {label}
          </div>
          <div className={`flex items-center ${className}`}>
            <HeadlessCheckbox
              ref={ref}
              disabled={disabled}
              checked={checked}
              onChange={onChange}
              className={({ checked, disabled }) =>
                `flex h-5 w-5 items-center justify-center rounded-4xl
               border-2 ${
                  checked
                    ? 'bg-[#383181] border-[#383181]'
                    : 'border-gray-300 bg-white'
                } ${
                  disabled
                    ? 'cursor-not-allowed opacity-50'
                    : 'cursor-pointer'
                } transition-colors duration-200`
              }
              {...props}
            >
              {({ checked }) => (
                <svg
                  className={`h-3 w-3 text-white transition-opacity ${
                    checked ? 'opacity-100' : 'opacity-0'
                  }`}
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
            </HeadlessCheckbox>
          </div>
        </div>
        {error && (
          <p className="mt-1 text-sm text-red-600">{error}</p>
        )}
        {/* Скрытый input для react-hook-form */}
        <input
          type="checkbox"
          name={name}
          ref={ref}
          checked={checked}
          onChange={(e) => onChange?.(e.target.checked)}
          style={{ display: 'none' }}
        />
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';